/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Join_CountInputs */

const en_auth_join_count = /** @type {(inputs: Auth_Join_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join 50,000+`)
};

const es_auth_join_count = /** @type {(inputs: Auth_Join_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Únete a más de 50,000`)
};

/**
* | output |
* | --- |
* | "Join 50,000+" |
*
* @param {Auth_Join_CountInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const auth_join_count = /** @type {((inputs?: Auth_Join_CountInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Join_CountInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_auth_join_count(inputs)
	return en_auth_join_count(inputs)
});